// extracted by mini-css-extract-plugin
export default {"item":"InspirationListItem_item__5R8S2","main":"InspirationListItem_main__7xgz2","image":"InspirationListItem_image__knC-F"};